import PrivateLayoutFrame from "../../helpers/PrivateLayoutFrame/PrivateLayoutFrame";

const UserLayout = ({ children }) => {
  return <PrivateLayoutFrame>{children}</PrivateLayoutFrame>;
};

export default UserLayout;
